import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/automations/templates')({
  head: () => ({
    meta: [{ title: 'Automation Templates | Tekst' }],
  }),
});
